import { mapTwoWayState } from 'schepotin-vuex-helpers';

export default {
    computed: {
        /**
         * Generates two way {@link https://vuejs.org/v2/guide/computed.html#Computed-Setter | computed properties}
         *
         * Documentation {@link https://www.npmjs.com/package/schepotin-vuex-helpers#maptwowaystate | mapTwoWayState}
         */
        ...mapTwoWayState({
            namespace: 'auth',
            prefix: true,
        }, [
            'id',
            'logged',
            'name',
            'email',
            'roleId',
            'password',
            'passwordConfirmation',
            'currentLang',
            'currentDirection',
            'token',
        ]),
        languages() {
            return [{
                language: 'en',
                direction: 'ltr',
            }, {
                language: 'he',
                direction: 'rtl',
            }, {
                language: 'zh',
                direction: 'ltr',
            }];
        },
        baseUrl() {
            return `${window.location.protocol}//api.${window.location.hostname.slice(6)}`;
        }
    },
    methods: {
        lang(language, direction) {
            /**
             * Set language.
             */
            this.$i18n.locale = language;
            this.authCurrentLang = language;
            this.$validator.locale = language;
            document.querySelector('html').setAttribute('lang', language);

            /**
             * Set direction.
             */
            this.authCurrentDirection = direction;
            document.querySelector('html').setAttribute('dir', direction);
        },
        async logout() {
            await this.$store.dispatch('auth/logout');

            this.$router.push({
                name: 'auth.login',
            });
        },
    },
};



// WEBPACK FOOTER //
// ./src/mixins/auth.js